import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { CompanyModel } from 'common/models/page-models/internship-company/internship-company/internship-company-data.model';
import { CompanyListingModel } from 'common/models/page-models/internship-company/internship-company/internship-company-grid.model';
import { CompanyGridMetaModel } from 'common/models/page-models/internship-company/internship-company/internship-company-grid-meta.model';


@Injectable({
    providedIn: 'root'
})
export class CompanyGridWidgetService extends GridWidgetService<CompanyModel, CompanyListingModel> {
    constructor(protected override ds: CompanyGridDataService, protected systemService: SystemService) {
        super(ds);
    }

     override prepareMetaModel(
        dataModel: CompanyModel,
        metaModel: CompanyGridMetaModel,
        routeData: WidgetModel
      ): Promise<CompanyGridMetaModel> {
        return new Promise<CompanyGridMetaModel>((resolve, reject) => {
            const startYear = 2022;
            const endYear = new Date().getFullYear();
            // const endYear = 2030;
            const yearOptions = [];
            for (let year = startYear; year <= endYear; year++) {
                yearOptions.push({
                key: year,
                value: year
                });
            }
            metaModel.properties['extraHeaderActions'].selectOptions = yearOptions;
            resolve(metaModel);
        });
      }


    getMetaModel(): MetaModel {
        const meta = new CompanyGridMetaModel().getMetaModel();
        return meta;
    }



}